import HeadphonesRoundedIcon from '@mui/icons-material/HeadphonesRounded';
import TranscriptIcon from '@mui/icons-material/RecordVoiceOver';
import { ActionButton } from '@pages/ActionButton';
import { useLibraryManager } from '@stores/LibraryManager/LibraryManager';
import { observer } from 'mobx-react';
import css from './TranscriptSearchSuggestion.module.scss';

/**
 * Empty-state shown when the user runs a visual/unified search on a
 * scope that includes audio-centric libraries and gets no results.
 *
 * Gated in SearchPage by `shouldSuggestTranscriptSearch` on the
 * search store — rendered exclusively in place of MomentGrid, so
 * it doesn't need to guard conditions internally.
 */
export const TranscriptSearchSuggestion = observer(() => {
  const libraryManager = useLibraryManager();
  const search = libraryManager.multiLibSearch;
  const reason = search.transcriptOnlySentence ?? '';

  return (
    <div className={css.root}>
      <div className={css.iconCircle}>
        <HeadphonesRoundedIcon className={css.icon} />
      </div>
      <div className={css.text}>
        <h1>No visual results</h1>
        <span>{reason}</span>
      </div>
      <ActionButton variant="primary" onClick={() => search.setResultType('transcript')}>
        <span className={css.ctaContent}>
          <TranscriptIcon className={css.ctaIcon} />
          Switch to transcript search
        </span>
      </ActionButton>
    </div>
  );
});
